module.exports = __webpack_public_path__ + "img/projects.c2aee26b.jpg";